"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { isWaveDirectMessage } from "@/helpers/waves/wave.helpers";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
interface WaveDropActionsCopyLinkProps {
  readonly drop: ApiDrop;
}
const WaveDropActionsCopyLink: React.FC<WaveDropActionsCopyLinkProps> = t0 => {
  const $ = _c(26);
  const {
    drop
  } = t0;
  const [copied, setCopied] = useState(false);
  const myStream = useMyStreamOptional();
  let t1;
  if ($[0] !== myStream?.directMessages.list) {
    t1 = myStream?.directMessages.list ?? [];
    $[0] = myStream?.directMessages.list;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const directMessageWaves = t1;
  const isTemporaryDrop = _temp;
  let t2;
  if ($[2] !== directMessageWaves || $[3] !== drop) {
    t2 = () => {
      if (isTemporaryDrop(drop)) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      } ?? undefined;
      const isDirectMessage = isWaveDirectMessage(drop.wave.id, waveDetails, directMessageWaves);
      const dropLink = `${publicEnv.BASE_ENDPOINT}${getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp: false
      })}`;
      navigator.clipboard.writeText(dropLink).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    };
    $[2] = directMessageWaves;
    $[3] = drop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const copyToClipboard = t2;
  let t3;
  if ($[5] !== drop) {
    t3 = isTemporaryDrop(drop);
    $[5] = drop;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isDisabled = t3;
  let t4;
  if ($[7] !== copied || $[8] !== isDisabled) {
    t4 = () => {
      if (isDisabled) {
        return "Unavailable";
      }
      if (copied) {
        return "Copied!";
      }
      return "Copy link";
    };
    $[7] = copied;
    $[8] = isDisabled;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getLinkText = t4;
  const t5 = `tw-text-iron-500 icon tw-px-2 tw-h-full tw-group tw-bg-transparent tw-rounded-full tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-text-[0.8125rem] tw-leading-5 tw-font-medium tw-transition tw-ease-out tw-duration-300 ${isDisabled ? "tw-opacity-50 tw-cursor-default" : "tw-cursor-pointer"}`;
  let t6;
  if ($[10] !== drop || $[11] !== isDisabled) {
    t6 = !isDisabled ? {
      "data-tooltip-id": `copy-link-${drop.id}`
    } : {};
    $[10] = drop;
    $[11] = isDisabled;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== copyToClipboard || $[15] !== isDisabled || $[16] !== t5 || $[17] !== t6) {
    t8 = <button className={t5} onClick={copyToClipboard} disabled={isDisabled} aria-label="Copy link" {...t6}>{t7}</button>;
    $[14] = copyToClipboard;
    $[15] = isDisabled;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== drop || $[20] !== getLinkText || $[21] !== isDisabled) {
    t9 = !isDisabled && <Tooltip id={`copy-link-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{getLinkText()}</span></Tooltip>;
    $[19] = drop;
    $[20] = getLinkText;
    $[21] = isDisabled;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default WaveDropActionsCopyLink;
function _temp(drop_0) {
  return drop_0.id.startsWith("temp-");
}